import { RouteConfig } from 'vue-router';

const projectGroupRoute = [
	{
		path: '/project-group/active',
		name: 'projectGroupActive',
		component: () => import(
			'../../views/ProjectGroup.vue'
			),
		meta: {
			label: 'router.label.projectGroup',
			subLabel: 'router.subLabel.projectGroupActive',
			can: 'project_group',
			navigationConfigurationName: 'project_group_accessmaster',
			hiddenOnProjectRoute: true,
			params: {
				type: 'active'
			}
		}
	},
	{
		path: '/project-group/inactive',
		name: 'projectGroupInactive',
		component: () => import(
			'../../views/ProjectGroup.vue'
			),
		meta: {
			label: 'router.label.projectGroup',
			subLabel: 'router.subLabel.projectGroupInactive',
			can: 'project_group',
			navigationConfigurationName: 'project_group_accessmaster',
			hiddenOnProjectRoute: true,
			params: {
				type: 'inactive'
			}
		}
	}
] as RouteConfig[];

export default projectGroupRoute;
